// extracted by mini-css-extract-plugin
export default {"root":"UserNavCustomer_root__Yz7PS","tab":"UserNavCustomer_tab__NS59h"};